import styled from 'styled-components';

import { COLORS, Chip } from '@treelab/panda';

export const Container = styled.div``

export const ChipPlain = styled(Chip.Plain)`
  margin-right: 4px;
  &:last-child {
    margin-right: 0;
  }
`;